import React from 'react';
import { LearningGlobalSummary } from '../types';

interface StatCardProps {
  label: string;
  value: number;
  subLabel: string;
  valueColor: string;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, subLabel, valueColor }) => (
  <div
    className="bg-white flex flex-col justify-between p-5 gap-3"
    style={{
      border: '1px solid #E5E7EB',
      borderRadius: '10px',
    }}
  >
    <p className="font-semibold text-[14px] leading-[17px] uppercase text-[#4B5563]">
      {label}
    </p>
    <p className="font-medium text-[36px] leading-[44px]" style={{ color: valueColor }}>
      {value}
    </p>
    <p className="font-medium text-[14px] leading-[17px] text-[#4B5563]">
      {subLabel}
    </p>
  </div>
);

interface StatCardsProps {
  summary: LearningGlobalSummary | null;
}

const StatCards: React.FC<StatCardsProps> = ({ summary }) => {
  if (!summary) return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 animate-pulse">
      {[1, 2, 3, 4].map(i => <div key={i} className="h-32 bg-gray-100 rounded-[10px]" />)}
    </div>
  );

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard
        label="Всего студентов"
        value={summary.total_students}
        subLabel={`В ${summary.total_applications} заявках`}
        valueColor="#1E61AF"
      />
      <StatCard
        label="В зоне риска"
        value={summary.at_risk_count}
        subLabel="Срок истекает"
        valueColor="#EF7744"
      />
      <StatCard
        label="Просрочено"
        value={summary.overdue_count}
        subLabel="Не завершили в срок"
        valueColor="#EF4444"
      />
      <StatCard
        label="Без активности"
        value={summary.no_activity_count}
        subLabel="0% прогресса"
        valueColor="#4B5563"
      />
    </div>
  );
};

export default StatCards;